import Instance from '../../../../utils/Axios';

const EnviarValidacaoIndividualAD = (ydata) => async (dispatch) => {
  const stateToken = localStorage.token;

  if (stateToken) {
    await Instance()
      .post('/obras/validacao/administradores/', { ydata })
      .then(({ data }) => {
        console.log(data);
        if (stateToken) {
          dispatch({ type: 'POST_VALIDACAO_INDIVIDUAL_AD', payload: data });
        }
      })
      .catch(({ err }) => console.log(err));
  }
};

export default EnviarValidacaoIndividualAD;
